import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Button, ButtonGroup, StepBox} from '../../Common/PageComponents';
import {joinSteps} from '../../../constants/join.constans';
import MessageBox from '../../Common/MessageBox';
import '../MemberService.scss';

class JoinCompletion extends Component {
  render() {
    return (
      <div>
        <StepBox activeIndex={3} steps={joinSteps} />
        <div className="membership-completion__title" style={{marginTop: '40px'}}>
          라이엇 게임즈 프리미엄 PC방
          <span className="membership-completion__subtitle">회원 가입이 완료되었습니다.</span>
        </div>

        <div className="membership-completion__description">
          라이엇 게임즈 프리미엄 PC방에서 제공하고 있는 상품 구매를 통해
          <br /> 원활한 PC방 서비스를 이용하시려면 아래 절차를 추가적으로 해주셔야 합니다.
        </div>

        <div style={{display: 'flex'}}>
          <MessageBox className="membership-completion__message-box">
            <h1>사업자등록증 사본을 꼭 접수해주세요.</h1>
            팩스 또는 1:1 문의를 통해 파일 첨부로 접수해주세요. <br />
            <ul>
              <li>고객센터: 1688-1011</li>
              <li>팩스: 02-863-4850</li>
            </ul>
            <div>
              * 가입 후 20일 이내 고객 센터로 사업자등록증 사본을 접수하지 않으실 경우 서비스 이용에 제한을 받으실 수
              있습니다.
            </div>
          </MessageBox>
          <MessageBox className="membership-completion__message-box">
            <h1>PC방에서 이용하시는 IP 대역을 등록해 주세요.</h1>
            상품 구매를 하더라도 PC방에서 이용하시는 IP대역을 등록하지 않으시면 PC방에서 사용하실 수 없습니다. 지금 바로
            등록해주세요.
            <ButtonGroup>
              <Link to="/my-pc-bang/management/ip-management">
                <Button>IP 대역 등록하기</Button>
              </Link>
            </ButtonGroup>
          </MessageBox>
        </div>
      </div>
    );
  }
}

export default JoinCompletion;
